var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.950562 13.6668H4.28389L13.0339 4.91676C13.2528 4.69789 13.4264 4.43805 13.5448 4.15208C13.6633 3.86612 13.7242 3.55962 13.7242 3.25009C13.7242 2.94056 13.6633 2.63406 13.5448 2.3481C13.4264 2.06213 13.2528 1.80229 13.0339 1.58342C12.815 1.36455 12.5552 1.19094 12.2692 1.07248C11.9833 0.954033 11.6768 0.893066 11.3672 0.893066C11.0577 0.893066 10.7512 0.954033 10.4652 1.07248C10.1793 1.19094 9.91943 1.36455 9.70056 1.58342L0.950562 10.3334V13.6668Z",
    stroke: "#0DB5B5",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.2a306f3168a69fceeec76123ca720047.svg";
export { ForwardRef as ReactComponent };